// src/hooks/countries/useForceDeleteCountry.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteCountry } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useForceDeleteCountry = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDelete,
        isPending: isForceDeleting,
    } = useMutation({
        mutationFn: forceDeleteCountry,
        onSuccess: (res) => {
            const message = res?.message || "Country permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete country");
        },
    });

    return {
        forceDeleteCountry: forceDelete,
        isForceDelete: isForceDeleting,
    };
};

export default useForceDeleteCountry;
